<template>
    <div class="header">
        <div class="line"></div>
        <div>{{title}}</div>
    </div>
</template>
<script>
    export default {
        props:{
            title: {
                type: String,
                default: '跟进提醒'
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        color: #333;
        padding: 12px 0;
        .line {
            width: 2px;
            height: 12px;
            background: #0082EF;
            border-radius: 1px;
            margin-right: 7px;
        }
    }
</style>